import { t } from 'i18next';
import { RightEnums } from 'src/enums/user-rights.enum';

export type UserRoleType = { abbreviation: string };
export interface Item {
  id: string;
  userRoleId: string | undefined;
  // description: string | undefined;
  permissionId: number[] | undefined;

  // formType: string;
  // rights: RightEnums[];
  // create: boolean;
  // edit: boolean;
  // delete: boolean;
  // read: boolean;
}

export interface RolePermissionDataType {
  id: number;
  name: string | undefined;
  description: string | undefined;
  permissions: number[] | undefined;
}

export interface EventPropsType {
  activeKey: string;
  defaultKey: string;
}

export const deleteConfirmTitles = () => ({
  title: t('general.deleteConfirmTitle'),
  okText: t('general.no'),
  cancelText: t('general.yes'),
});
